import { AxiosRequestConfig } from 'axios';
import { axiosInstance } from '@services/axios-instance';
import { AppSettingsData, QuestionnaireData } from '@types';

export class AppService {
    static init() {
        return new AppService();
    }

    getSettings(config?: AxiosRequestConfig) {
        return axiosInstance.post<AppSettingsData>('/v2/app/settings/', config);
    }

    updateSettings(data: Partial<AppSettingsData>, config?: AxiosRequestConfig) {
        return axiosInstance.patch<AppSettingsData>('/v2/company/', data, config);
    }

    getOrderQuestionnaire() {
        return axiosInstance.get<QuestionnaireData>('/v2/app/order-questionnaire/');
    }
}
